import { render, staticRenderFns } from "./FacilityRisk.vue?vue&type=template&id=1a08a14c&scoped=true&"
import script from "./FacilityRisk.vue?vue&type=script&lang=js&"
export * from "./FacilityRisk.vue?vue&type=script&lang=js&"
import style0 from "./FacilityRisk.vue?vue&type=style&index=0&id=1a08a14c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a08a14c",
  null
  
)

export default component.exports